import { ArrowRight } from '@tencent/odc-iconpack';
import React from 'react';

import './index.scss';

export type IToolCard = {
  icon: string | React.ReactNode;
  name: string;
  desc: string;
  onClick?: () => void;
}

const ToolCard = (props: IToolCard) => {
  const { icon, name, desc, onClick } = props;
  return (
    <div className="odc-tool-card" onClick={onClick}>
      <div className="odc-tool-card-content">
        <div className="odc-tool-card-icon">
          {typeof icon === 'string' ? <img src={icon} alt="" /> : icon}
        </div>
        <div className="odc-tool-card-name">{name}</div>
        <div className="odc-tool-card-desc">{desc}</div>
      </div>
      <ArrowRight className="odc-tool-card-arrow" />
    </div>
  );
};

export default ToolCard;